<template>
    <div>
        <b-row sm="10">
            <b-col sm="4" class="col text-right"
                ><label>รหัสวัตถุดิบ</label></b-col>
            <b-col sm="6"><input
                    class="form-control"
                    type="text"
                    v-model="material_replace.code"
                    disabled/></b-col>
        </b-row>
        <br />
        <b-row sm="10">
            <b-col sm="4" class="col text-right"><label>ชื่อวัตถุดิบ</label></b-col>
            <b-col sm="6"><input
                    class="form-control"
                    type="text"
                    v-model="material_replace.name"
                    disabled/></b-col>
        </b-row>
        <br />
        <b-row sm="11">
            <b-col sm="4" class="col text-right">
                <label>จำนวนวัตถุดิบคงเหลือ ({{material_replace.unit}})</label>
            </b-col>
            <b-col sm="6">
                <input
                    class="form-control"
                    type="text"
                    v-model="material_replace.quantity"
                    disabled/>
            </b-col>
        </b-row>
        <br />
        <b-row sm="11">
            <b-col sm="4" class="col text-right">
                <label>จำนวนเบิก ({{material_replace.unit}})</label>
            </b-col>
            <b-col sm="6">
                <input
                    class="form-control"
                    type="number"
                    v-model="form.quantity"
            /></b-col>
        </b-row>
        <br />
        <b-row sm="10">
            <b-col sm="4" class="col text-right"><label>หมายเหตุ</label></b-col>
            <b-col sm="6">
                <textarea class="form-control" v-model="form.reason">
                </textarea>
            </b-col>
        </b-row>
        <br />
        <b-row sm="11">
            <b-col sm="4" class="col text-right">
                <label>วันที่เบิกวัตถุดิบ</label>
            </b-col>
            <b-col sm="6">
                <date-picker
                        v-model="form.date"
                        type="date"
                        format="DD/MM/YYYY"
                        lang="en"
                        placeholder="วันที่เบิก" >
                </date-picker>
            </b-col>
        </b-row>
        <br />
        <b-row>
            <div class="col text-center">
                <button
                    type="button"
                    :disabled="form.onSave"
                    class="btn btn-success"
                    @click="onSubmitExport">
                    <icon name="save" style="width: 25px"></icon> บันทึก</button>
                &nbsp&nbsp
                <button type="button"
                        @click="cancelModal"
                        class="btn btn-outline-secondary">
                    <icon name="times" style="width: 25px"></icon> ยกเลิก
                </button>
            </div>
        </b-row>
        <!--<pre class="alert alert-primary">{{ material_replace }}</pre>-->
    </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import DatePicker from 'vue2-datepicker'

export default {
    name: "export-material-modal",
    components: {DatePicker},

    data() {
        return {
            id: "",
            form: {
                quantity: "",
                po: "",
                date: "",
                reason: "",
                code: "",
                onSave: false,
            }
        };
    },
    created() {
        this.getDateNow();
    },
    computed: {
        ...mapState({
            user: state => {
                return state.Auth.user;
            },
            material_replace: state => {
                return state.Material.replace_data;
            }
        })
    },
    methods: {
        onSubmitExport() {
            if(!this.form.quantity || this.form.quantity < 0){
                alert("กรุณาใส่จำนวนที่ต้องการเบิก");
            }
            else if(!this.form.date){
                alert("กรุณาเลือกวันที่");
            }
            else{
                let data = {
                    export_date: moment(this.form.date).format("YYYY-MM-DD"),
                    material_id : this.material_replace.id,
                    quantity: this.form.quantity,
                    reason: this.form.reason,
                    user_id: this.user.id
                };
                if (this.material_replace.quantity < data.quantity) {
                    alert("ไม่สามารถเบิกวัตถุดิบได้ เนื่องจากวัตถุดิบที่ท่านต้องการไม่เพียงพอ");
                } else {
                    this.form.onSave = true;
                    this.$emit("submit", data);
                    this.form = {
                        quantity: "",
                        po: "",
                        date: "",
                        reason: "",
                        code: "",
                        onSave: false,
                    }
                }
            }
        },
        cancelModal(){
            this.$emit("submit", "cancel");
            this.form = {
                quantity: "",
                po: "",
                date: "",
                reason: "",
                code: "",
                onSave: false,
            }
        },
        getDateNow() {
            const currentDate = moment().format("YYYY-MM-DD");
            this.form.date = currentDate;
        }
    }
};
</script>

<style scoped></style>
